// Implement function to execute user provided function code in a web worker
// https://leapcell.medium.com/a-deep-dive-into-javascript-sandboxing-bbb0773a8633

/**Executes user provided javascript function string in an isolated web worker */
export default function (fnString: string, params: Record<string, string | number | boolean> = {}) {
  return new Promise((resolve, reject) => {
    const blob = new Blob(
      [
        `
      self.onmessage = function(e) {
        const [body, params] = e.data;
        try {
          let fn;
          const isBlock = body.trim().startsWith('{') && body.trim().endsWith('}');
          if (isBlock) {
            // Full function body with braces: use as is
            fn = new Function(...Object.keys(params), body);
          } else {
            // Single expression: wrap in return
            fn = new Function(...Object.keys(params), 'return ' + body);
          }
          const result = fn(...Object.values(params));
          self.postMessage({ result });
        } catch (error) {
          self.postMessage({ error: error.message });
        }
      };
    `,
      ],
      { type: 'application/javascript' },
    )

    const worker = new Worker(URL.createObjectURL(blob))

    worker.onmessage = (e) => {
      const { result, error } = e.data
      worker.terminate()
      if (error) {
        reject(new Error(error))
      } else {
        resolve(result)
      }
    }

    worker.onerror = (e) => {
      worker.terminate()
      reject(e)
    }

    worker.postMessage([fnString, params])
  })
}
